import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import './index.css';
//import App from './App';
//import LoginView from './components/loginView';
import {Restricted } from './components/restricted';
import {BrowserRouter, Route, Redirect} from 'react-router-dom'
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

const AsyncApp = Loadable({loader: () => import('./App'), loading: () => null });
//const AsyncUserMasterListView = Loadable({loader: () => import('./components/userMasterListView'), loading: () => null });
const AsyncLoginView = Loadable({loader: () => import('./components/loginView'), loading: () => null });

var routes = (<div>				
	            <Route exact path="/" render={() => <Redirect to="/login" component={Restricted(AsyncApp)} />} />
				<Route path="/app" component={Restricted(AsyncApp)} ></Route>	              
	            <Route path="/login" component={AsyncLoginView}></Route>
		</div>);

ReactDOM.render(<BrowserRouter children={routes} />, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js